import QuarterGroupReport from './quarter-group-report.vue'
export default QuarterGroupReport
